module.exports = __webpack_public_path__ + "img/piece-complete-8.866d36dc.svg";